<template>
  <div class="orderList">
    <div class="head">
        <div style="flex:9;padding-left:20px;">
          <span style="flex:5;">宝贝</span>
          <span style="flex:2;">单价</span>
          <span style="flex:2;">数量</span>
        </div>
        <div style="flex:8;padding-right:20px;">
          <span style="flex:1;">收货人</span>
          <span style="flex:1;">实付款</span>
          <span style="flex:1;">状态</span>
          <span style="flex:1;">操作</span>
        </div>
    </div>
    <div v-if="flag">
      <div class="content" v-for="(item,index) in orderList" :key="index">
          <div class="top">
              <div class="left">
                  <span class="shopName" @click="toStore(item.shopId)"><img :src="item.shopLogo" alt="">{{item.shopName}}</span>
                  <span class="time">{{item.createTime}}</span>
                  <span class="orderCode">订单号：{{item.orderFormid}}</span>
              </div>
              <div class="right">
                  <img class="cur-poi" v-if="item.state==5" src="../../../static/image/shanchu@2x.png" alt="" @click="$emit('isDelete',item.orderId)">
              </div>
          </div>
          <div class="productBox">
              <div class="product">
                  <div class="left fs13">
                      <div class="box" v-for="(items,indexs) in item.skus" :key="indexs">
                          <div class="desc cur-poi" @click="toProductDetail(item.shopId,items)">
                              <img :src="items.image" alt="">
                              <div>
                                  <p class="name">{{items.productName}}</p>
                                  <p class="size font-color-999"><span v-for="(val,idx) in items.values" :key="idx">{{val}}</span></p>
                              </div>
                          </div>
                          <div class="price">¥{{items.price}}</div>
                          <div class="num">
                            <p class="fs14">{{items.number}}</p>
                            <p v-if="items.afterState===1" class="font-color-FF7 fs14">(售后审核中)</p>
                            <p v-if="items.afterState===2" class="font-color-FF7 fs14">(退款中)</p>
                            <p v-if="items.afterState===3" class="font-color-FF7 fs14">(退货中)</p>
                            <p v-if="items.afterState===4" class="font-color-FF7 fs14">(退款成功)</p>
                            <p v-if="items.afterState===5" class="font-color-FF7 fs14">(退款失败)</p>
                            <p v-if="items.afterState===6" class="font-color-FF7 fs14">(审核不通过)</p>
                            <p v-if="items.afterState===7" class="font-color-FF7 fs14">(售后评审中)</p>
                            <p v-if="items.afterState===8" class="font-color-FF7 fs14">(退货完成，拒绝退款)</p>
                            <p v-if="items.afterState===10" class="font-color-FF7 fs14">(售后审核通过)</p>
                          </div>
                      </div>
                  </div>
                  <div class="right" :class="item.skus.length>1?'right_line':''">
                      <div class="consignee">{{item.receiveName}}</div>
                      <div class="actualPay"><div>
                          <p class="fs13 mar-bot-5">¥{{(item.orderPrice - item.discountPrice).toFixed(2)}}</p>
                          <p class="fs13">(含运费：¥{{item.logisticsPrice}})</p>
                      </div>
                      </div>
                      <div class="status">
                      <div>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state==1">待付款</p>
                        <div v-if="item.state==1">
                          <p class="time fs12 mar-bot-10 font-color-999 flex-items"><img style="width:13px;height:13px;margin-right:5px;" src="../../../static/image/alarm_clock@2x.png" alt=""> 剩余时间{{item.time | formatMinutes}}分</p>
                        </div>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state==2">待发货</p>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state==3">待收货</p>
                          <p class="fs13 mar-bot-5 font-color-71B" v-if="item.state==4">已完成</p>
                          <p class="fs13 mar-bot-5 font-color-999" v-if="item.state==5">已关闭</p>
                          <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state==6">待成团</p>
                          <p class="fs13 cur-poi" @click="toOrderDetail(item.orderId)">订单详情</p>
                      </div>
                      </div>
                      <div class="operate">
                          <div>
                              <el-button class="fs13 mar-bot-5" size="small" v-if="item.state==1 || item.paymentState==0 && item.state==6" @click="getUrl(item.orderId)" v-throttle>去付款</el-button>
                              <el-button class="fs13 mar-bot-5" size="small" v-if="item.state==2" @click="remind(item.orderId)" v-throttle>提醒发货</el-button>
                              <el-button class="fs13 mar-bot-5" size="small" v-if="item.state==3 && item.ifAfter==1" @click="$emit('isConfirm',item.orderId)" v-throttle>确认收货</el-button>
                              <el-button class="fs13 mar-bot-5" size="small" v-if="item.state==4 || item.state==5" @click="buyAgain(item.orderId)" v-throttle :disabled="item.shopDiscountId!=0 || item.shopGroupWorkId!=0 || item.shopSeckillId!=0">再次购买</el-button>
                              <p class="fs13 tex-und cur-poi" @click="$emit('isCancel',item.orderId)" v-if="item.state==1 || item.state==6" v-throttle>取消订单</p>
                              <p class="fs13 tex-und cur-poi" @click="toAfterSale(item)" v-if="item.state==2" v-throttle>退货/退款</p>
                              <p class="fs13 tex-und cur-poi" @click="$emit('isRefund',item)" v-if="item.state==3 && item.ifAfter || item.state==4 && item.ifAfter" v-throttle>退货/退款</p>
                              <p class="fs13 tex-und cur-poi" v-if="item.state==4 && item.ifNotComment ===1"  @click="toEvaluate(item)" v-throttle>评价</p>
                              <p class="fs13 tex-und cur-poi" v-if="item.state==3" @click="toOrderDetail(item.orderId)" v-throttle>查看物流</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <el-pagination :current-page="page" :page-size="5" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='total'></el-pagination>
    </div>
    <div class="noorder" v-else>
        <img src="../../../static/image/noorder@2x.png" alt="">
        <p class="fs20 font-color-999">你还没有订单哦～</p>
        <router-link to="/">
            <el-button>去首页看看</el-button>
        </router-link>
    </div>
    <el-dialog
      class="weChat"
      :title="`请使用微信扫一扫支付￥${payInfo.money}`"
      :visible.sync="weChatDialog"
      :before-close="handleClose"
      width="30%">
      <div class="weChatBox">
        <div class="qCode">
          <img :src="payInfo.url" alt="">
          <img src="../../assets/images/weiXintit.png" alt="">
        </div>
        <div class="weChatInfo">
          <img src="../../assets/images/imgPay.png" alt="">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
export default {
    props: ['orderList', 'total', 'page', 'flag'],
    mixins: [listSearchMixin],
    data () {
        return {
          payInfo: {},
          weChatDialog: false,
          chatTimer: '',
          endTime: '',
          endTime1: ''
        }
    },
  filters: {
    formatMinutes: function (value) {
      let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60))
      if (minutes < 10) {
        return '0' + minutes
      } else {
        return minutes
      }
    }
  },
    methods: {
        ...mapMutations({
          setCartNumber: 'SET_CARTNUMBER',
          setShoppingCart: 'SET_SHOPPINGCART'
        }),
        // 跳转到商品详情
        toProductDetail (id, item) {
          let data = {
            shopId: id,
            productId: item.productId,
            skuId: item.skuId
          }
          this.$router.push({
            path: '/productDetail',
            query: {
              proData: JSON.stringify(data)
            }
          })
        },
        // 分页器跳转
        handleCurrentChange (val) {
            this.$emit('handleCurrentChange', val)
        },
        // 提醒发货
        remind (id) {
            this.$message({
              message: '已提醒卖家发货',
              type: 'success'
            })
        },
        // 跳转到店铺
        toStore (id) {
            this.$router.push({
                path: '/store',
                query: {
                    shopId: id
                }
            })
        },
        // 跳转到订单详情
        toOrderDetail (id) {
            this.$router.push({
                path: '/orderDetail',
                query: {
                    orderId: id
                }
            })
        },
        // 再次购买
        buyAgain (id) {
            let self = this
            let params = {
                url: api.buyAgain,
                method: 'PUT',
                data: {
                  orderId: id
                }
            }
            self.sendReq(params, (res) => {
              if (res.code === '200') {
                 self.$router.push('/shopping-trolley')
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 跳转到评价
        toEvaluate (data) {
            this.$router.push({
                path: '/evaluate',
                query: {
                    product: JSON.stringify(data)
                }
            })
        },
        // 申请售后
        toAfterSale (item) {
          this.$router.push({
            path: '/afterSale',
            query: {
              orderData: JSON.stringify(item),
              state: 1
            }
          })
        },
        // 去支付
      checkPay (paramsData) {
        setTimeout(() => {
          let self = this
          let params = {
            url: api.checkPay + `?collageId=${paramsData.collageId}&money=${paramsData.money}&orderId=${paramsData.orderId}&type=2`,
            method: 'GET'
          }
          self.sendReq(params, (res) => {
            if (res.code === '200') {
              if (res.data.code === 'SUCCESS') {
                self.$message({
                  message: '支付成功！',
                  type: 'success'
                })
                clearInterval(self.chatTimer)
                self.getTrolleyList()
                self.weChatDialog = false
                self.toOrderDetail(paramsData.orderId)
              }
            } else {
              clearInterval(self.chatTimer)
              self.$message({
                message: res.message,
                type: 'error'
              })
              self.weChatDialog = false
            }
          })
        }, 0)
      },
      // 购物车列表
      async getTrolleyList () {
        const vm = this
        const params = {
          url: api.getTrolleyList,
          method: 'GET'
        }
        vm.sendReq(params, res => {
          const d = res.data
          let cartNumber = 0
          // console.log(d)
          if (d.length) {
            d.forEach(j => {
              cartNumber = cartNumber + j.skus.length
            })
          }
          this.setShoppingCart(d)
          this.setCartNumber(cartNumber)
        })
      },
      // 去支付
      getUrl (id) {
        let self = this
        let params = {
          url: api.getPayCode,
          method: 'GET',
          payload: {
            orderId: id
          }
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
            self.payInfo = res.data
            self.weChatDialog = true
            self.chatTimer = setInterval(() => {
              self.checkPay(res.data)
            }, 3000)
          } else {
            self.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      },
      handleClose () {
        this.$confirm('确认取消支付？')
          .then(_ => {
            clearInterval(this.chatTimer)
            this.weChatDialog = false
          })
          .catch(_ => {})
      }
    }
}
</script>
<style lang="scss" scoped>
.orderList{
    width: 100%;
    .noorder{
        width: 100%;
        text-align: center;
        padding: 100px 0;
        p{
            margin-bottom: 20px;
        }
        .el-button{
            background-color: #FF7800;
            color: #FFFFFF;
            font-weight: normal;
            border-radius: 0;
        }
    }
    .head{
        box-sizing: border-box;
        width: 100%;
        height: 44px;
        background-color: #F1F2F7;
        display: flex;
        align-items: center;
        text-align: center;
        margin-bottom: 20px;
        div{
            display: flex;
        }
    }
    .content{
        width: 100%;
        margin-bottom: 20px;
        border: 1px solid #E5E5E5;
        border-bottom: 0;
        box-sizing: border-box;
        .top{
            width: 100%;
            font-size: 13px;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #F3F3F3;
            .left{
                flex: 15;
                .shopName{
                    margin-left: 20px;
                    margin-right: 60px;
                    cursor: pointer;
                    img{
                        width: 16px;
                        height: 16px;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                .time{
                    margin-right: 60px;
                }
            }
            .right{
                flex: 2;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-right: 20px;
            }
        }
        .productBox{
            width: 100%;
            box-sizing: border-box;
            .product{
                width: 100%;
                display: flex;
                .left{
                    flex: 9;
                    .box{
                        padding: 20px 0 20px 20px;
                        display: flex;
                        border-bottom: 1px solid #E5E5E5;
                        .desc{
                            flex: 5;
                            display: flex;
                            img{
                                width: 86px;
                                height: 86px;
                                margin-right: 10px;
                            }
                            div{
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                .name{
                                    font-size: 14px;
                                }
                                .size{
                                    font-size: 13px;
                                    span{
                                        margin-right: 10px;
                                    }
                                    span:last-child{
                                        margin-right: 0;
                                    }
                                }
                            }
                        }
                        .price,.num{
                            flex: 2;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
                .right{
                    padding: 20px 20px 20px 0;
                    flex: 8;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    .actualPay,.consignee,.status,.operate{
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        div{
                            text-align: center;
                            .el-button{
                                border: 1px solid #FF7800;
                                color: #FF7800;
                                border-radius: 0;
                            }
                        }
                    }
                }
                .right_line{
                    border-left: 1px solid #E5E5E5;
                }
            }
        }
    }
    >>>.el-pagination{
        margin-top: 40px;
        text-align: right;
        .el-pager{
            li:not(.disabled):hover{
                color: #FF7800;
            }
            li:not(.disabled).active{
                background-color: #FF7800;
            }
            li:not(.disabled).active:hover{
                color: #F4F4F5;
            }
        }
    }
  .weChatBox {
    display: flex;
    img {
      width: 100%;
    }
    .qCode {
      width: 50%;
      text-align: center;
      img {
        width: 80%;
      }
    }
    .weChatInfo {
      width: 50%;
    }
  }
  .weChat {
    >>> .el-dialog__body {
      background: #FFFFFF;
    }
  }
  >>> .el-dialog {
    width: 33% !important;
    .el-dialog__body {
      background: #F8F8F8;
    }
    .el-dialog__header {
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
      .dialog-footer {
        text-align: center;
        button {
          height: 45px;
          width: 160px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/orderList.vue